import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/billing';
import * as api from '../services/api';
import { getProfile } from '../ducks/auth';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
import { load, loaded } from 'ducks/loading';
// let toastId = '';


function* getPlan() {
  try {
    yield put(load());
    let res;
    if (localStorage.getItem('pvd') == 'wix') {
      res = yield call(api.GET, '/getPlans?fm=wix');
    }
    else {
      res = yield call(api.GET, '/getPlans');
    }
    if (res.status == 'success') {
      yield put(actions.getPlanSuccess(res.data));
    }
    else {
      yield put(actions.errorInGatPlan(true));
      toast.error('Error in get plans');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInGatPlan(true));
  }
}

//get user bill
function* getUserBill() {
  try {
    yield put(load());
    const res = yield call(api.GET, '/getBillingHistory');
    if (res.status == 'success') {
      yield put(actions.getBillSuccess(res.data));
    }
    else {
      yield put(actions.errorInGatBill(true));
      toast.error('Error in get user billing data');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInGatBill(true));
  }
}

//delete user card
function* deleteUserCard(action) {
  try {
    yield put(load());
    const res = yield call(api.DELETE, '/deleteCard?id=' + action.data);
    if (res.status == 'success') {
      toast.info(res.m);
      yield put(getProfile());
    }
    else {
      yield put(actions.errorInDeleteCard(true));
      toast.error('Error in delete card');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInDeleteCard(true));
  }
}

//download Invoice
function* downloadInvoice(action) {
  try {
    // yield put(load());
    const res = yield call(api.GET, '/downloadInvoice?iv=' + action.data.iv);
    if (res.status == 'success') {
      toast.success(res.m);
      window.location.href = res.data.download_url;
    }
    else {
      toast.error(res.m);
      yield put(actions.downloadInvoiceError(true));
    }
    // yield put(loaded());
  } catch (error) {
    yield put(actions.downloadInvoiceError(true));
  }
}

//update primary card 
function* updPrimary(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/defaultCard', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(getProfile());
    }
    else {
      yield put(actions.updPrimaryError(true));
      toast.error('Error in update default card');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.updPrimaryError(true));
  }
}

//getDueAmount
function* getDueAmount(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/getDueAmount', action.data);
    if (res.status == 'success') {
      yield put(actions.getDueAmountSuccess(res.data));
      // yield put(actions.cancelSubscriptionSuccess(res.data));
    }
    else {
      yield put(actions.errorIngetDueAmount(true));
      toast.error('Error in get DueAmount');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorIngetDueAmount(true));
  }
}

//upgradeSubscription
function* upgradeSubscription(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/upgradeSubscription', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.createSubscriptionSuccess(res));
      yield put(actions.upgradeSubscriptionSuccess(true));
      yield put(getProfile());
      // yield put(actions.upgradeSubscriptionSuccess(res.data));
    }
    else {
      yield put(actions.errorInUpgradeSubscription(true));
      toast.error('Error in upgrade subscription');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInUpgradeSubscription(true));
  }
}

// createSubscription
function* createSubscription(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/createSubscription', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.createSubscriptionSuccess(res));
      yield put(getProfile());
    }
    else if (res.status == 'error') {
      toast.error(res.m);
    }
    else {
      yield put(actions.errorInCreateSubscription(true));
      toast.error('Error in create subscription');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInCreateSubscription(true));
  }
}

//create user card at chargebee
function* createUserCard(action) {
  try {
    // yield put(load());
    const res = yield call(api.POST, '/createCard', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      if (window.location.pathname == '/payment') {
        window.location.reload();
      }
      else {
        yield put(getProfile());
        yield put(actions.createSubscriptionSuccess(res));
        yield put(actions.createCardSuccess(true));
      }

    }
    else if (res.status == 'error') {
      toast.error(res.m);
      yield put(actions.errorInCreateCard(res));
      // yield put(loaded());
    }
    else {
      yield put(actions.errorInCreateCard(true));
      toast.error(res.m);
      // yield put(loaded());
    }
    // yield put(loaded());
  } catch (error) {
    yield put(actions.errorInCreateCard(true));
  }
}


//cancelSubscription
function* cancelSubscription(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/cancelSubscription', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(getProfile());
    }
    else {
      yield put(actions.errorInCancelSubscription(true));
      toast.error('Error in cancel subscription');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.errorInCancelSubscription(true));
  }
}

export function* watch() {
  yield takeEvery(actions.GET_PLAN, getPlan);
  yield takeEvery(actions.CREATE_CARD, createUserCard);
  yield takeEvery(actions.CREATE_SUBSCRIPTION, createSubscription);
  yield takeEvery(actions.GET_BILL, getUserBill);
  yield takeEvery(actions.DELETE_CARD, deleteUserCard);
  yield takeEvery(actions.DOWNLOAD_INVOICE, downloadInvoice);
  yield takeEvery(actions.UPD_PRIMARY, updPrimary);
  yield takeEvery(actions.GET_DUE_AMOUNT, getDueAmount);
  yield takeEvery(actions.UPGRADE_SUBSCRIPTION, upgradeSubscription);
  yield takeEvery(actions.CANCEL_SUBSCRIPTION, cancelSubscription);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/billing.js